<template>
  <div class="dashboard-designer cdsp_dashboard" :style="dashboardStyle">
    <div class="canvas-panel-container"  ref="previewContainer">
      <canvas-panel :dashboardName="layoutObj.dashboardName"  :chartDirection="chartDirection" :chartPreviewMode="chartPreviewMode" :previewMode="previewMode" @sort-change="handleSortChange" @drill-item-click="handleDrillItemClick" @handle-table-command="handleTableCommand" @table-page-change="handleTablePageChange" ref="grid" :gridLayout.sync="layoutObj.layout"
          :previewFlag="getPreviewFlag" @chartSelect="handleChartSelect" @grid-resize="handleGridResize" :chartConfigHandler="chartConfigHandler"></canvas-panel>
    </div>
  </div>
</template>

<script>
// 移除 Vuex 依赖，使用内部状态管理
import '../../assets/style/dashboard.less'
import canvasPanel from './canvasPanelPreview.vue'
// import { getDashboardConfigDetail } from 'cdsp_sharedKernel/service'
import { updatePanelWidget } from '../../utils/index'
import { exportImage } from '../../utils/utils'
export default {
  name: 'Preview',
  props: {
    chartDirection: {
      type: String,
      default: 'rtl'
    },
    chartPreviewMode: {
      type: String,
      default: 'dialog'
    },
    previewMode: {
      type: String,
      default: 'drawer'
    },
    layoutObj: {
      type: Object,
      default: () => {
        return {
          layout: [],
          dashboardName: '未命名',
        }
      },
    },
    // 外部传入的 widgets 数据
    widgets: {
      type: Array,
      default: () => []
    },
    chartConfigHandler: {
      type: Function,
      default: (conf) => conf,
    },
  },
  components: { canvasPanel },
  data() {
    return {
      exportingImage:false,
      isPc: true,
      selectItem: {},
      // 内部状态管理
      dashboardDesignerWidth: 0,
    }
  },
  computed: {
    // 内部状态计算属性
    getDashboardDesignerWidth() {
      return this.dashboardDesignerWidth
    },
    getPreviewFlag() {
      return true
    },
    dashboardStyle() {
      let initAreas = '"action action" "components setting" "canvas setting" "components-mode setting"'
      let previewAreas = '"canvas"'
      return {
        gridTemplateColumns: !this.getPreviewFlag ? '1fr 420px' : '1fr',
        gridTemplateAreas: this.getPreviewFlag ? previewAreas : initAreas,
        gridTemplateRows: !this.getPreviewFlag ? '50px 48px 1fr' : '48px 1fr',
      }
    },
    mobileLayout: {
      get() {
        return JSON.parse(JSON.stringify(this.layoutObj.layout))
      },
      set() {
        // 占位setter 避免报错
      },
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    async handleExportImage(vm) {
      this.exportingImage = true
      const previewContainer = this.$refs.previewContainer;
      const dashboardName = this.layoutObj.dashboardName || '看板'
      exportImage(vm ?? this, previewContainer, previewContainer.querySelector(".root-container"), dashboardName)
    },
    handleSortChange(column) {
      this.$emit('sort-change', column)
    },
    handleDrillItemClick(data, item) {
      this.$emit('drill-item-click', data, item)
    },
    handleTableCommand(command, item) {
      this.$emit('handle-table-command', command, item)
    },
    handleTablePageChange(current, pageSize) {
      this.$emit('table-page-change', current, pageSize)
    },
    // 处理 tab 切换事件
    handleChartSelect(chartData) {
      this.selectItem = chartData
    },
    handleGridResize(item) {
      console.log('Grid resized:', item)
    },
    getResponsiveGrid(type) {
      // const el = document.querySelector('.gridlayout')
      // const {name} = getCanvasWidth(el)
      // const whole = responsiveMap[name]
      const whole = 12
      return type === 'whole' ? whole : whole / 2
    },
  },
  beforeDestroy() {
  },
}
</script>

<style scoped lang="less">
.dashboard-designer {
  display: grid;
  display: -ms-grid;
  height: 100%;
  width: 100%;
  overflow: auto;
  //grid-template-areas:
  //      "action action"
  //      "components setting"
  //      "canvas setting"
  //      "components-mode setting";
  grid-template-rows: 50px 48px 1fr;

  .action-panel-container {
    grid-area: action;
    display: flex;
    position: relative;
    z-index: 310;
  }

  .components-panel-container {
    grid-area: components;
    display: flex;
    align-items: center;
    position: relative;
  }

  .setting-panel-container {
    grid-area: setting;
    display: flex;
    background: var(--bi-jz-bg-color);
  }

  .canvas-panel-container {
    grid-area: canvas;
    position: relative;
    height: 100%;
  }
}
</style>
